import React, { FC } from 'react';
import { TypeLandingPageHeroFields } from '@/core/generated-types';
import {
  ContainedImage,
  FullImage,
  SideBySide,
} from '@/components/common/LandingPageHero/versions';
import { CONTENT_TYPE_LANDING_PAGE_HERO } from '@/core/constants';

export const LandingPageHero: FC<TypeLandingPageHeroFields> = (props) => {
  const versionMap = {
    [CONTENT_TYPE_LANDING_PAGE_HERO.FULL_IMAGE]: <FullImage {...props} />,
    [CONTENT_TYPE_LANDING_PAGE_HERO.FULL_IMAGE_W_WAVE]: (
      <FullImage {...props} />
    ),
    [CONTENT_TYPE_LANDING_PAGE_HERO.SIDE_BY_SIDE]: <SideBySide {...props} />,
    [CONTENT_TYPE_LANDING_PAGE_HERO.CONTAINED]: <ContainedImage {...props} />,
    [CONTENT_TYPE_LANDING_PAGE_HERO.CONTAINED_W_TRIPTYCH]: (
      <ContainedImage {...props} />
    ),
  };

  return versionMap[props.version];
};
